// @workflow assistant.send-message
/**
 * Incremental Server-Sent Events parser (the WHATWG "event stream" format), for reading the agent
 * stream through fetch(). EventSource can't be used: it only does GET and can't send the auth
 * header or a JSON body.
 * Only `data` and `id` matter here; comments, `event` and `retry` are ignored.
 * No Vue or path-alias imports, so `npm run test:unit` (node --test) can load it directly.
 */

/**
 * @param {(message: { id: string|null, data: string }) => void} onMessage
 * @returns {{ push(chunk: string): void, end(): void }}
 */
export function createSseParser(onMessage) {
  let buffer = '';
  let data = [];
  let id = null;

  function reset() {
    data = [];
    id = null;
  }

  function line(text) {
    if (text === '') {
      if (data.length) onMessage({ id, data: data.join('\n') });
      reset();
      return;
    }
    if (text[0] === ':') return;
    const colon = text.indexOf(':');
    const field = colon < 0 ? text : text.slice(0, colon);
    let value = colon < 0 ? '' : text.slice(colon + 1);
    if (value[0] === ' ') value = value.slice(1);
    if (field === 'data') data.push(value);
    else if (field === 'id') id = value;
  }

  return {
    push(chunk) {
      buffer += chunk;
      for (;;) {
        const cr = buffer.indexOf('\r');
        const lf = buffer.indexOf('\n');
        if (cr < 0 && lf < 0) return;
        const at = cr < 0 ? lf : lf < 0 ? cr : Math.min(cr, lf);
        // A CR at the very end may be the first half of a CRLF split across chunks: wait for more.
        if (buffer[at] === '\r' && at === buffer.length - 1) return;
        const width = buffer[at] === '\r' && buffer[at + 1] === '\n' ? 2 : 1;
        line(buffer.slice(0, at));
        buffer = buffer.slice(at + width);
      }
    },
    /** The stream closed: an unfinished message is dropped. */
    end() {
      buffer = '';
      reset();
    },
  };
}
